<template>
  <div class="allAuthorized">
    <el-table :data="listsTable" border style="width: 100%">
      <template slot="empty">
        <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt>
        <br>暂无数据
      </template>
      <el-table-column prop="agentUserName" label="姓名"></el-table-column>
      <el-table-column prop="mobile" label="手机号码"></el-table-column>
      <el-table-column prop="mail" label="邮箱"></el-table-column>
      <el-table-column prop="mail" label="授权状态">
        <template slot-scope="scope">
          <span v-if="scope.row.enabled==1">已启用</span>
          <span v-if="scope.row.enabled==0">已禁用</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            v-if="scope.row.enabled==0"
            @click="isStart(scope.row.id,'1')"
            style="color: #28BF15;cursor:pointer;"
          >启用</span>
          <span
            v-if="scope.row.enabled==1"
            @click="isStart(scope.row.id,'0')"
            style="color: #E88078;cursor:pointer;"
          >禁用</span>
          <span v-if="scope.row.enabled==0" style="color: #C8C8C8;cursor:pointer;">授权签章</span>
          <span
            v-if="scope.row.enabled==1"
            @click="isAuthorization(scope.row.id)"
            style="color: #E88078;cursor:pointer;"
          >授权签章</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="fenYeBox">
      <el-pagination
        v-if="showPagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <Dialog
      :visible="dialogStatus"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog('dialogStatus')"
      :width="'450px'"
      class="dialogStatusBox"
      v-loading="requestIng"
    >
      <div slot="dialog" class="changeStatus">
        <p>是否禁用/启用该签约方？</p>
        <div class="authHandlerBox" style="margin:0 auto">
          <div class="button cursorPointer" @click="cancelFn('dialogStatus')">取消</div>
          <div class="button buttonActive cursorPointer" @click="trueChange">确定</div>
        </div>
      </div>
    </Dialog>
    <auth-seal
      v-if="dialogVisibleTwo"
      :listImg="listImg"
      @close="dialogVisibleTwo=false"
      :userAgentId="currentUserAgentId"
      @uploadList="isAuthorization"
    ></auth-seal>
    <Dialog
      :visible="errorHint"
      :dialogTitle="'消息提示'"
      :width="'300px'"
      @closeDialog="closeDialog('errorHint')"
      class="errorBox"
    >
      <div class="errorBoxdialog errorBoxDialogCenter" slot="dialog">
        <p>{{errorMessage}}</p>
        <div class="authHandlerBox" style="margin:0 auto;justify-content: center;">
          <div class="button buttonActive cursorPointer" @click="errorHint = false">确定</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "../../../../common/Dialog.vue";
import authSeal from "./authSeal.vue";
export default {
  data() {
    return {
      requestIng: false,
      listsTable: [],
      listImg: [],
      showPagination: false,
      dialogStatus: false,
      dialogVisibleTwo: false,
      idx: "",
      num: "",
      errorMessage: "",
      errorHint: false,
      currentUserAgentId: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var queryStres = {
        type: "2",
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      BaseApi.createRpcToken("/agent/allAgentList", queryStres, "get")
        .then(
          data => {
            console.log(data);
            this.listsTable = data.datas.list;
            this.total = data.datas.totalRow;
            if (data.datas.totalRow > 10) {
              this.showPagination = true;
            } else {
              this.showPagination = false;
            }
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    isStart(id, num) {
      this.dialogStatus = true;
      this.idx = id;
      this.num = num;
      console.log(this.num);
    },
    closeDialog(flag) {
      this[flag] = false;
    },
    cancelFn(flag) {
      this[flag] = false;
    },
    trueChange() {
      this.requestIng = true;
      var queryStr = {
        id: this.idx,
        status: this.num
      };
      console.log(queryStr);
      BaseApi.createRpcToken("/agent/updateAgentEnable", queryStr, "post")
        .then(
          data => {
            console.log(data);
            this.requestIng = false;
            this.dialogStatus = false;
            if (data.datas.code == 5001) {
              this.errorMessage = data.datas.message;
              this.errorHint = true;
              return;
            }
            this.init();
          },
          data => {
            this.requestIng = false;
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    isAuthorization(id = this.currentUserAgentId) {
      var params = { userAgentId: id };
      this.currentUserAgentId = id;
      console.log(params);
      BaseApi.createRpcToken("/seal/authorized2SealList", params, "post")
        .then(
          data => {
            console.log(data);
            if (data.datas != null) {
              this.listImg = data.datas.resultList;
              this.dialogVisibleTwo = true;
            }
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    }
  },
  components: {
    BaseApi,
    Dialog,
    authSeal
  }
};
</script>
<style lang="scss">
.allAuthorized {
  width: 100%;
  th {
    padding: 0 10px;
    box-sizing: border-box;
    word-wrap: break-word;
    text-align: center;
  }
  .cell {
    padding: 0 10px;
  }
  th:nth-child(1),
  td:nth-child(1) {
    width: 13.2%;
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 19.8%;
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 22%;
  }
  th:nth-child(4),
  td:nth-child(4) {
    width: 10.2%;
  }
  th:nth-child(5),
  td:nth-child(5) {
    width: 16%;
    span:nth-child(1) {
      margin-right: 10%;
    }
  }
  .el-pagination {
    padding: 0;
    float: right;
  }
  table {
    table-layout: auto;
    tr {
      height: 32px;
      th {
        background: #f9f9f9;
      }
      td {
        text-align: center;
      }
    }
    thead {
      width: 100%;
      background: #f9f9f9;
      color: #505050;
      input {
        vertical-align: middle;
        width: 12px;
        height: 12px;
      }
    }
    tbody {
      tr {
        color: #969696;
        height: 48px;
        input {
          width: 12px;
          height: 12px;
        }
      }
    }
    .el-checkbox__inner:hover {
      border-color: #e88078;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #dcdfe6;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #e88078;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #e88078;
      background: #e88078;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #dcdfe6;
      background: #fff;
    }
  }
  .fenYeBox {
    margin-top: 20px;
  }
  .authorizationTrigger {
    margin-top: 22px;
    height: 32px;
    line-height: 32px;
    .el-checkbox {
      margin-left: 30px;
      margin-right: 11px;
    }
    div {
      input[type="checkbox"] {
        width: 12px;
        height: 12px;
        border: 1px solid #db4437;
        margin: 0 22px;
        vertical-align: middle;
      }
      .el-checkbox__inner:hover {
        border-color: #e88078;
      }
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #dcdfe6;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #e88078;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-color: #e88078;
        background: #e88078;
      }
      .authorTion {
        display: inline-block;
        width: 100px;
        height: 30px;
        border: 1px solid #db4437;
        color: #db4437;
        margin-left: 20px;
      }
      .authorTion:hover {
        background-color: #a5303d;
        color: #fff;
      }
    }
  }
  .dialogStatusBox {
    .header {
      height: 60px;
      line-height: 60px;
      .el-icon-close {
        top: 22px;
      }
    }
    .changeStatus {
      height: 200px;
      p:nth-child(1) {
        width: 100%;
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      p:last-child {
        text-align: center;
        span {
          display: inline-block;
          width: 100px;
          height: 32px;
          line-height: 32px;
          border: 1px solid #D81212;
          color: #db4437;
        }
        span:first-child {
          margin-right: 20px;
          color: #fff;
          background-color: #D81212;
        }
      }
    }
  }
  .dialogVisibleTwoBox {
    .header {
      height: 60px;
      line-height: 60px;
      .el-icon-close {
        top: 22px;
      }
    }
  }
  .errorBox {
    .el-dialog {
      width: 400px !important;
    }
    .header {
      height: 45px !important;
      line-height: 45px !important;
      font-size: 18px !important;
    }
    .errorBoxdialog {
      height: 200px;
      overflow: hidden;
      padding: 0 15px;
      text-align: center;
      box-sizing: border-box;
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      font-size: 16px;
      padding-top: 20px;
      .defaileBox {
        height: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 30px;
          margin-bottom: 10px;
        }
      }
      .contentShow {
        width: 100%;
        text-align: left;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .errorBoxDialogCenter {
      justify-content: space-around;
      align-items: center;
    }
    .successBox {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 200px;
      background-color: #fff;
      span {
        font-size: 18px;
        color: #646464;
        margin-top: 10px;
      }
    }
  }
}
</style>
